import TextField, { TextFieldProps } from './TextField';

type Props = TextFieldProps;

const NumberField = (props: Props) => <TextField type="number" fullWidth {...props} />;

export default NumberField;
